<mat-form-field appearance="fill" [formGroup]="formGroup">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="control">
    <mat-option>--</mat-option>
    <mat-option *ngFor="let option of optionList" [value]="option.storedValue">
      {{ option.shownValue }}
    </mat-option>
  </mat-select>
  <mat-error *ngIf="shouldDisplayErrorMessage && control.errors && control.touched">
    <span
      [innerHTML]="
        getDefaultValidatorErrorMessage(objectFn.keys(control.errors)[0])
      "
    ></span>
  </mat-error>
</mat-form-field>
